export const buildTime = (totalHours: number | undefined | null, t2: (key: string) => string) => {
  if (totalHours === undefined || totalHours === null) {
    return `N/A`;
  }

  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);

  const parts = [];
  if (hours > 0) {
    const hourLabel = hours === 1 ? t2('Hours').slice(0, -1) : t2('Hours'); // "Hora" o "Horas"
    parts.push(`${hours} ${hourLabel}`);
  }
  if (minutes > 0) {
    const minuteLabel = minutes === 1 ? t2('Minutes').slice(0, -1) : t2('Minutes'); // "Minuto" o "Minutos"
    parts.push(`${minutes} ${minuteLabel}`);
  }

  if (parts.length === 0) return `0 ${t2('Minutes')}`;

  return parts.join(' ');
};
